import React from "react"
import { Search as SearchIcon, X } from "react-feather"

const InputField = ({
    isSearch = false,
    resetQuery,
    query,
    handleQuery,
    placeholder = "placeholder",
    classes,
}) => {
    return (
        <div className={`relative w-full`}>
            {isSearch && (
                <SearchIcon
                    className=" absolute left-2 top-1/2 -translate-y-1/2 text-neutral-400"
                    size={20}
                    strokeWidth={1.5}
                />
            )}
            <input
                className={`${isSearch ? "px-8" : "px-4"} py-2 w-full border rounded-xl border-neutral-500 dark:border-neutral-800  bg-color-2 fg-color-1 placeholder-neutral-400  focus:outline-neutral-600 dark:focus:outline-neutral-800 ${classes}`}
                name=""
                type="text"
                value={query}
                onChange={(e) => handleQuery(e)}
                placeholder={placeholder}
                autoComplete="off"
                autoCorrect="off"
                spellCheck="false"
            />
            {query && (
                <X
                    className="absolute right-2 text-neutral-400 hover:text-red-400 top-1/2 -translate-y-1/2 cursor-pointer"
                    onClick={resetQuery}
                    size={32}
                    strokeWidth={1}
                />
            )}
            {/*         {(query !== '') ? <X className='absolute right-2 text-neutral-400 hover:text-red-400 top-1/2 -translate-y-1/2 cursor-pointer' onClick={resetQuery} size={32} strokeWidth={1} /> : ''}
             */}{" "}
        </div>
    )
}

export default InputField
